import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { removeAuth } from "../store/appSlice";

import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query'

export const baseApiURL = process.env.REACT_APP_API_BASE_URL;

const get_cookies = function() {
  return Object.fromEntries(document.cookie.split('; ').map(v=>v.split(/=(.*)/s).map(decodeURIComponent)))
}


export const  internalQuery = fetchBaseQuery({
  baseUrl: baseApiURL,
  credentials: 'include',
  prepareHeaders: (headers, api) => {
    const cookies = get_cookies();
    const csrf = cookies['csrftoken'] ?? undefined;
    if(csrf) {
      headers.set('X-CSRFTOKEN', csrf);
    }
    return headers
  }
})

export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>
 = async (args, api, extraOptions) => {
  try {
    let result = await internalQuery(args, api, extraOptions);
    if (result.error && result.error.status === 401) {
      api.dispatch(removeAuth());
    }
    return result;
  } catch(e) {
    console.log('baseQuery error', e);
    throw e;
  }
}